import {mapGetters} from 'vuex';
import * as mutations from '../store/mutations';

import PalyanceV2Api from '../api/palyance-v2-api';
import MixinContactForm from './contact-form';

export default {
  name: 'MixinAspsp',
  computed: {
    ...mapGetters([
      'affiliateConfig',
      'localeconfig',
      'paymentMethod',
      'paymentId',
      'locale',
      'walletUid',
      'sfId',
      'isAspspEligibleSepa',
      'isAspspEligibleBankCard',
      'isAspspEligible',
      'countryExcluded',
      'aspspPaymentInformations',
      'paymentAccountIdentifier',
      'holderName',
      'mandateId',
      'paymentId',
      'pciToken',
      'doubleOptin'
    ])
  },
  mixins: [
    MixinContactForm
  ],
  data() {
    return {
      palyanceV2Api: new PalyanceV2Api()
    };
  },
  methods: {
    /**
     * Prefill form if we have ONLY the walletId provided
     * @param {object} context Context (this)
     * @param {function} afterPrefillForm
     */
    async getEligibilityData(context, afterPrefillForm) {
      if (!this.walletUid) {
        console.log('[vanguard] ASPSP sfId provided OR any walletUid provided, aborting process.');
        return;
      }

      const data = await this.palyanceV2Api.getEligibility(this.walletUid, this.paymentMethod, this.affiliateConfig.affiliateId);

      const country = this.$data.billingCountry;

      if (this.localConfig && this.localConfig.countriesExcluded.length > 0 && this.localConfig.countriesExcluded.includes(country)) {
        this.$store.commit(mutations.SET_COUNTRIEXCLUDED, true);
        this.prefillForm(data[this.paymentMethod].content);
        console.log(`[vanguard] The country ${country} is excluded and prefill based on walletId is disabled.`);
        return;
      }

      if (JSON.stringify(data) === '{}') {
        return;
      }

      // this is used to display the prefilled blue banner
      this.$store.commit(mutations.SET_IS_ASPSP_ELIGIBLE, true);

      if (data.bank_card.paymentIdentifier) {
        this.$store.commit(mutations.SET_IS_ASPSP_ELIGIBLE_BANK_CARD, true);
      }
      if (data.sepa.paymentIdentifier) {
        this.$store.commit(mutations.SET_IS_ASPSP_ELIGIBLE_SEPA, true);
      }

      this.$store.commit(mutations.SET_ASPSP_PAYMENT_INFORMATIONS, data);

      this.setAspspData()

      this.setAspspDataContent(context, afterPrefillForm);
    }
    ,
    /**
     * Generate full address in a single line
     * @param {object} data Object containing prefill data
     * @param {string} data.FIRSTNAME
     * @param {string} data.LASTNAME
     * @param {string} data.BILLINGSTREET3__C
     * @param {string} data.BILLINGSTREET1__C
     * @param {string} data.BILLINGSTREET2__C
     * @param {string} data.BILLINGSTREET4__C
     * @param {string} data.BILLINGZIPCODE__C
     * @param {string} data.BILLINGCITY__C
     * @param {string} data.BILLINGCOUNTRY__C
     * @returns {string} Full address
     */
    formatFullAddress(data) {

      const billingStreet = data.BILLINGSTREET3__C;
      const billingZipCode = data.BILLINGZIPCODE__C;
      const billingCity = data.BILLINGCITY__C;

      const shippingStreet = data.SHIPPINGSTREET3__C || data.BILLINGSTREET3__C;
      const shippingZipCode = data.SHIPPINGZIPCODE__C || data.BILLINGZIPCODE__C;
      const shippingCity = data.SHIPPINGCITY__C || data.BILLINGCITY__C;
      const billingAddress = `${billingStreet}, ${billingZipCode} ${billingCity}`;
      const shippingAddress = `${shippingStreet}, ${shippingZipCode} ${shippingCity}`;

      if (billingAddress !== shippingAddress) {
        this.$store.commit(mutations.SET_ISDISTINCT_ADRESS, true);
        return {
          billingAddress,
          shippingAddress
        };
      } else {
        this.$store.commit(mutations.SET_ISDISTINCT_ADRESS, false);
        return billingAddress;
      }
    },
    /**
     * Prefill form if we have ONLY the walletId provided
     * @param {object} context Context (this)
     * @param {function} afterPrefillForm
     */
    applyAspspPrefill(context, afterPrefillForm) {
      this.prefillForm(context);

      this.$nextTick(() => {
        afterPrefillForm();
      });
    },
    editAspspPrefillData() {
      this.useSameAddressForShipping = false;
      this.$store.commit(mutations.SET_IS_ASPSP_PREFILL_EDITED_BY_USER, true);
    },
    removeWalletIdFromURLAndRedirect() {
      if (window.location.search.length > 0) {
        const searchParameters = {};

        window.location.search.slice(1, window.location.search.length).split('&').forEach(pair => {
          const [key, value] = pair.split('=');
          searchParameters[key] = value;
        });

        delete searchParameters.walletId;

        const queryParameters = Object.keys(searchParameters).map(key => `${key}=${searchParameters[key]}`);

        window.location = `${window.location.origin}${window.location.pathname}?${queryParameters.join('&')}`;
      }
    },

    setAspspData() {
      if (this.aspspPaymentInformations.sepa && this.aspspPaymentInformations.sepa.content) {
        this.$store.commit(mutations.SET_PREFILL_DATA, this.aspspPaymentInformations['sepa'].content );
        this.$store.commit(mutations.SET_ASPSP_EMAIL, this.aspspPaymentInformations['sepa'].content.EMAIL);
        this.$store.commit(mutations.SET_ASPSP_FULL_ADDRESS, this.formatFullAddress(this.aspspPaymentInformations['sepa'].content));
      }
      else if (this.aspspPaymentInformations.bank_card && this.aspspPaymentInformations.bank_card.content) {
        this.$store.commit(mutations.SET_PREFILL_DATA, this.aspspPaymentInformations['bank_card'].content );
        this.$store.commit(mutations.SET_ASPSP_EMAIL, this.aspspPaymentInformations['bank_card'].content.EMAIL);
        this.$store.commit(mutations.SET_ASPSP_FULL_ADDRESS, this.formatFullAddress(this.aspspPaymentInformations['bank_card'].content));
      }

      if (!this.isAspspEligible) {
        return;
      }

      /**
       * The paymentIdentifier might be empty, in this case we wont set aspsp eligibility to true
       */
      if (this.aspspPaymentInformations[this.paymentMethod]) {
        this.$store.commit(mutations.SET_PAYMENT_ACCOUNT_IDENTIFIER, this.aspspPaymentInformations[this.paymentMethod].paymentAccountIdentifier);
        this.$store.commit(mutations.SET_PAYMENT_ID, this.aspspPaymentInformations[this.paymentMethod].paymentIdentifier);
        this.$store.commit(mutations.SET_MANDATE_ID, this.aspspPaymentInformations[this.paymentMethod].mandateIdentifier);
        this.$store.commit(mutations.SET_HOLDER_NAME, this.aspspPaymentInformations[this.paymentMethod].holderName);
      }
      else {
        this.$store.commit(mutations.SET_PAYMENT_ACCOUNT_IDENTIFIER, null);
        this.$store.commit(mutations.SET_PAYMENT_ID, null);
        this.$store.commit(mutations.SET_MANDATE_ID, null);
        this.$store.commit(mutations.SET_HOLDER_NAME, null);
      }

      if (this.aspspPaymentInformations['bank_card'] && this.aspspPaymentInformations['bank_card'].pciToken) {
        this.$store.commit(mutations.SET_PCI_TOKEN, this.aspspPaymentInformations['bank_card'].pciToken);
      }
      else {
        this.$store.commit(mutations.SET_PCI_TOKEN, null);
      }

      if (this.aspspPaymentInformations['sepa'] && this.aspspPaymentInformations['sepa'].doubleOptin) {
        this.$store.commit(mutations.SET_DOUBLE_OPTIN, this.aspspPaymentInformations['sepa'].doubleOptin);
      }
      else {
        this.$store.commit(mutations.SET_DOUBLE_OPTIN, null);
      }
    },
    setAspspDataContent(context, afterPrefillForm) {
      /**
       * We will prefill with the wallet contact informations ONLY if there is no sfId provided
       * and as well some data in content key
       */
      this.applyAspspPrefill(context, afterPrefillForm);
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/aspsp.js